module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "app-body"
  }, [_c('form', {
    staticClass: "search-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search_query),
      expression: "search_query"
    }],
    staticClass: "form-ipt",
    attrs: {
      "type": "text",
      "name": "search_query",
      "placeholder": "Suchen...",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.search_query)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search_query = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "form-btn",
    attrs: {
      "type": "submit",
      "name": "submit"
    }
  }, [_vm._v("Suchen")])]), _vm._v(" "), (_vm.results.length > 0) ? _c('ul', {
    staticClass: "search-results",
    attrs: {
      "id": "search-results"
    }
  }, [_c('h2', {
    staticClass: "search-results__title"
  }, [_vm._v("Resultate")]), _vm._v(" "), _vm._l((_vm.results), function(item) {
    return _c('li', {
      staticClass: "search-result song"
    }, [_c('img', {
      staticClass: "song__cover",
      attrs: {
        "src": item.album.images[2].url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "song__info"
    }, [_c('span', {
      staticClass: "song__title"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', {
      staticClass: "song__artist"
    }, [_vm._v(_vm._s(item.artists.map(function(artist) {
      return artist.name
    }).join(", ")))])]), _vm._v(" "), _c('button', {
      staticClass: "song__action-btn",
      on: {
        "click": function($event) {
          _vm.suggestSong(item, $event)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus-circle"
    })])])
  }), _vm._v(" "), (_vm.results.length >= (_vm.limit + _vm.offset)) ? _c('footer', {
    staticClass: "search-results__footer"
  }, [_c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.showMoreResults
    }
  }, [_vm._v("Mehr Anzeigen")])]) : _vm._e()], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c865d9da"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Search.vue
// module id = 215
// module chunks = 1